var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import AntdSpin from 'antd/es/spin';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
import { LoadingOIcon } from '../icon';
AntdSpin.setDefaultIndicator(React.createElement(LoadingOIcon, { spin: true }));
/**
 * 默认的描述文案
 */
let defaultTip = '';
const Spin = forwardRef((props, ref) => {
    const { tip, prefixCls: customizePrefixCls, className } = props, rest = __rest(props, ["tip", "prefixCls", "className"]);
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('spin', customizePrefixCls);
    return (React.createElement(AntdSpin, Object.assign({ ref: ref, className: classNames([prefixCls, className]), tip: defaultTip && typeof tip === 'undefined' ? defaultTip : tip }, rest)));
});
const FullSpin = Spin;
FullSpin.setDefaultIndicator = AntdSpin.setDefaultIndicator;
/**
 * 设置全局默认的描述文案
 * @param tip 描述文案
 */
FullSpin.setDefaultTip = (tip) => {
    defaultTip = tip;
};
export default FullSpin;
